/* 🤖 this file was generated by svg-to-ts */
export const fthrCalendar: {
    name: 'fthr-calendar';
    data: string;
} = {
    name: 'fthr-calendar',
    data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" class="feather feather-calendar" viewBox="0 0 24 24"><rect width="18" height="18" x="3" y="4" rx="2" ry="2"/><path d="M16 2v4M8 2v4M3 10h18"/></svg>`,
};
